import { createI18n, type LanguageMap } from '@tencent/wphk-i18n';
export type { InterpolationData, LanguageConfig, LanguageMap } from '@tencent/wphk-i18n';

import zhCnConfig from './zh-cn/main.json';
import enConfig from './en/main.json';
import zhHkConfig from './zh-hk/main.json';

const langMap: LanguageMap = {
  'zh-hk': zhHkConfig,
  'zh-cn': zhCnConfig,
  en: enConfig,
};

export const i18nInstance = createI18n(langMap);

export const { i18n } = i18nInstance;
